import { useMutation } from '@tanstack/react-query';

import { mapIdentityValidationResponse } from '../mappers';
import { validateIdentityNumber } from '../services';
import {
  normalizeCpfForApi,
  normalizeRutForApi,
} from '../utils/identityDocument';
import { INVALID_IDENTITY_NUMBER } from '../utils/registration.constants';
import { IS_BR } from '../utils/registrationConfig';

const VALIDATE_IDENTITY_MUTATION_KEY = [
  'lead',
  'identity-number',
  'validate',
  'registration',
];

function leadErrorResponseBody(error) {
  if (error?.name !== 'LeadRequestError') return null;
  const body = error?.data?.data;
  return body && typeof body === 'object' ? body : null;
}

export function useValidateIdentityNumber({ onSuccess, onError } = {}) {
  return useMutation({
    mutationKey: VALIDATE_IDENTITY_MUTATION_KEY,
    mutationFn: async ({ rawValue }) => {
      try {
        const dto = await validateIdentityNumber({
          identity_number: IS_BR
            ? normalizeCpfForApi(rawValue)
            : normalizeRutForApi(rawValue),
        });
        const result = mapIdentityValidationResponse(dto);
        if (!result.valid) {
          const err = new Error(result.message || INVALID_IDENTITY_NUMBER);
          err.leadApiCode = result.message;
          throw err;
        }
        return result;
      } catch (e) {
        const body = leadErrorResponseBody(e);
        if (body) {
          const result = mapIdentityValidationResponse(body);
          if (!result.valid) {
            const err = new Error(result.message || INVALID_IDENTITY_NUMBER);
            err.leadApiCode = result.message;
            throw err;
          }
        }
        throw e;
      }
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError,
  });
}
